import { makeStyles } from '@material-ui/core';
import { TMNATheme } from 'tmna-theme';

export const useStyles = makeStyles<TMNATheme>(() => ({
    card: {
        height: '100%',
    }
}));